import $axios from "@/service/httpServer";
// const baseUrl = "http://yapi.newhope.cn/mock/452";
// const baseUrl = 'http://10.3.4.199:8913';
// const baseUrl = "http://10.3.4.67:8913";
import { baseUrl } from "./oldNew";
// 销售经理
// 搜索
// export const searchSaleManager = (p) =>
//   $axios.get(`${baseUrl}/marketing/recommend/App/distributeSearch`, p);
export const searchSaleManager = (p) =>
  $axios.get(`${baseUrl}/marketing/recommend/App/recommendList`, p);
// 搜索-统计
// export const searchSaleManagerTatol = (p) =>
//   $axios.get(
//     `${baseUrl}/marketing/recommend/App/distributeSearchStatistical`,
//     p
//   );
export const searchSaleManagerTatol = (p) =>
  $axios.get(`${baseUrl}/marketing/recommend/App/statusSearchStatistical`, p);
// 置业顾问
// 搜索
export const searchAdviser = (p) =>
  $axios.get(`${baseUrl}/marketing/recommend/App/recommendList`, p);
// 搜索-统计
// export const searchAdviserTatol = (p) =>
//   $axios.get(`${baseUrl}/marketing/recommend/App/adviserSearchStatistical`, p);
export const searchAdviserTatol = (p) =>
  $axios.get(`${baseUrl}/marketing/recommend/App/statusSearchStatistical`, p);
